import { SubscriptionStates } from '@/src/typings';

export const SIDETALK_WEB_PUSH_ID: string = 'web.com.sidetalk.push';

export const DB_INSTANCE_NAME: string = 'Sidetalk' as const;
export const DB_INSTANCE_VERSION: number = 1 as const;
export const DB_INSTANCE_PN_STORE: string = 'PN' as const;

export const defaultContactListId: number = 0;

export const NOTIFICATION_VALID_SENDER: string = 'sidetalk';

export const API_ERRORS: Record<string, string> = {
    FAILED_SUBSCRIBE: 'FAILED_SUBSCRIBE',
    FAILED_UNSUBSCRIBE: 'FAILED_UNSUBSCRIBE',
    FAILED_NOTIFY: 'FAILED_NOTIFY',
    EMPTY_SUBSCRIPTION: 'EMPTY_SUBSCRIPTION',
    INVALID_DATA: 'INVALID_DATA',
    FAILED_PUSH_PACKAGE_CREATION: 'FAILED_PUSH_PACKAGE_CREATION',
    INVALID_PUSH_PACKAGE_CREATION_DATA: 'INVALID_PUSH_PACKAGE_CREATION_DATA',
};

export const SUBSCRIPTION_STATES: SubscriptionStates = {
    UNSUPPORTED: {
        id: 'UNSUPPORTED',
        interactive: false,
        pushEnabled: false,
    },
    INITIALIZING: {
        id: 'INITIALIZING',
        interactive: false,
        pushEnabled: false,
    },
    PERMISSION_DENIED: {
        id: 'PERMISSION_DENIED',
        interactive: false,
        pushEnabled: false,
    },
    PERMISSION_GRANTED: {
        id: 'PERMISSION_GRANTED',
        interactive: true,
    },
    PERMISSION_PROMPT: {
        id: 'PERMISSION_PROMPT',
        interactive: true,
        pushEnabled: false,
    },
    ERROR: {
        id: 'ERROR',
        interactive: false,
        pushEnabled: false,
    },
    STARTING_SUBSCRIBE: {
        id: 'STARTING_SUBSCRIBE',
        interactive: false,
        pushEnabled: true,
    },
    SUBSCRIBED: {
        id: 'SUBSCRIBED',
        interactive: true,
        pushEnabled: true,
    },
    STARTING_UNSUBSCRIBE: {
        id: 'STARTING_UNSUBSCRIBE',
        interactive: false,
        pushEnabled: false,
    },
    UNSUBSCRIBED: {
        id: 'UNSUBSCRIBED',
        interactive: true,
        pushEnabled: false,
    },
};
